<script setup lang="ts">
const zones = [
  {
    name: 'Mayenne et nord Mayenne',
    text: "Historiquement implantés à Mayenne, nous intervenons pour tous vos projets de menuiserie, agencement et dépannage de l'habitat.",
  },
  {
    name: 'Laval et agglomération',
    text: "Nous intervenons également sur Laval et ses alentours pour vos projets de rénovation, d'amélioration de l'habitat et vos interventions dépannage.",
  },
  {
    name: 'La Baule et le littoral',
    text: 'Présents à La Baule Escoublac, nous accompagnons les projets sur le littoral : menuiserie, agencement sur mesure et terrasses bois.',
  },
]
</script>

<template>
  <section class="section zones">
    <div class="container">
      <span class="eyebrow">Zones d'intervention</span>
      <h2>Un artisan proche de chez vous</h2>
      <div class="grid grid--3 zones__grid">
        <div v-for="z in zones" :key="z.name" class="zones__card">
          <h3>{{ z.name }}</h3>
          <p>{{ z.text }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.zones__grid {
  margin-top: 22px;
}
.zones__card {
  background: #fff;
  border: 1px solid var(--border);
  border-top: 3px solid var(--green);
  border-radius: var(--radius);
  padding: 22px;
  box-shadow: var(--shadow-sm);
}
.zones__card h3 {
  color: var(--green-dark);
}
.zones__card p {
  margin: 0;
  color: var(--ink);
  font-size: 0.95rem;
}
</style>
